import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { money } from '../../utils/helpers'

const CartBottom = () => {
  const dispatch = useDispatch()
  const { cart } = useSelector((state) => state.cart)
  const makePermalink = () => {
    return cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',')
  }

  return (
    <div className='pt-6 border-t before:border-[rgba(33,33,33,0.25)]'>
      <div className='flex justify-between text-second text-sm leading-4 mb-6'>
        Subtotal
        <span className='text-second text-sm leading-4'>{money(cart.items_subtotal_price)}</span>
      </div>
      <a className='button w-full !bg-black !text-white !border-black hover:!bg-white hover:!border-black hover:!text-black' href='/cart'>
        Checkout
      </a>
      <a className='button button--secondary !border-black w-full mt-3.5' href={`/cart/${makePermalink()}?payment=shop_pay`}>
        <img className='h-5' src={window.globalIcons['icon-shop-pay']} alt='ShopPay' />
      </a>
    </div>
  )
}

export default CartBottom